import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import env from './config/index'
import {post, get,put,Delete,upload} from 'network/db'
import md5 from 'js-md5';
import 'assets/style/normalize.min.css'

import Antd from 'ant-design-vue'

import 'ant-design-vue/dist/antd.css'

Vue.prototype.$md5 = md5;
Vue.prototype.$store = store
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$put = put
Vue.prototype.$delete = Delete
Vue.prototype.$upload = upload
Vue.prototype.$env = env

Vue.config.productionTip = false
Vue.use(Antd)
// Vue.use(VueAxios, axios)

// Test
new Vue({
	router,
	store,
  render: h => h(App),
}).$mount('#app')
